import { useState, useEffect } from 'react';
import { Breakpoints } from '../types/types';
import { breakpoints } from '../config/config';

const useBreakpoint = () => {

  const [currentBreakpoint, setCurrentBreakpoint] = useState<keyof Breakpoints | null>(null);
  const [isLandscape, setIsLandscape] = useState(false);
  const [isMobileLandscape, setIsMobileLandscape] = useState(false);


  useEffect(() => {
    const handleWindowResize = () => {
      for (const breakpoint in breakpoints) {
        const mediaQuery = window.matchMedia((breakpoints as any)[breakpoint]);
        if (mediaQuery.matches) {
          setCurrentBreakpoint(breakpoint as keyof Breakpoints);
          break;
        }
      }

      const isTablet = window.matchMedia("(max-width: 1400px) and (max-height: 1030px)").matches;
      const mediaQuery = window.matchMedia("(orientation: landscape)");

      const isMobile = window.matchMedia("(max-width: 1000px)").matches;

      if (isTablet && mediaQuery.matches) {
        setIsLandscape(true);
      } else {
        setIsLandscape(false);
      }

      if (isMobile && mediaQuery.matches) {
        setIsMobileLandscape(true);
      } else {
        setIsMobileLandscape(false);
      }
    };

    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, [breakpoints]);

  const isMobile = currentBreakpoint === "isMobile" || isMobileLandscape;
  const isTablet = currentBreakpoint === "isTablet";
  const isDesktopSmall = currentBreakpoint === "isDesktopSmall";
  const isDesktop = currentBreakpoint === "isDesktop";
  const isFourK = currentBreakpoint === "isFourK";

  

  return { isMobile, isTablet, isDesktopSmall, isDesktop, isFourK, isLandscape, isMobileLandscape};
};

export default useBreakpoint;
